module.exports = __webpack_public_path__ + "img/immoby-logo.4ddbd837.svg";